/**
 * api 常量文件夹
 */

/**
 * 生产环境
 */
const prod = {
  // API_URL: "https://appsrv.hitpaw.com/app",
  // WS_API_URL: "wss://appsrv.hitpaw.com/app",
  // API_V2_URL: "https://appsrv.hitpaw.com/api/v2/",
  API_URL: "https://api.hitpaw.com/app",
  WS_API_URL: "wss://api.hitpaw.com/app",
  API_V2_URL: "https://api.hitpaw.com/api/v2/",
  googleUrl: "https://account.afirstsoft.com/api/v1/auth/google-oauth"
};

/**
 * 开发和测试环境
 */
const dev = {
  API_URL: "https://hitpaw-test-api.afirstsoft.cn/app",
  WS_API_URL: "wss://hitpaw-test-api.afirstsoft.cn/app",
  API_V2_URL: "https://hitpaw-test-api.afirstsoft.cn/api/v2/",
  googleUrl: "https://account-test-api.afirstsoft.cn/api/v1/auth/google-oauth"
};

let api_config = process.env.NODE_ENV === "development" || process.env.REACT_APP_BUILD_ENV === "development" ? dev : prod;


/*
dockerdev
dockertest
dockerprod
dockerstage
dockeruat
*/
console.log('REACT_APP_BUILD_ENV_DOCKER',process.env.REACT_APP_BUILD_ENV_DOCKER);
let ENVdocker = process.env.REACT_APP_BUILD_ENV_DOCKER;
if (ENVdocker === 'dockerdev') {
  let dockerdev = {
    API_URL: "https://hitpaw-dev-api.afirstsoft.cn/app",
    WS_API_URL: "wss://hitpaw-dev-api.afirstsoft.cn/app",
    API_V2_URL: "https://hitpaw-dev-api.afirstsoft.cn/api/v2/",
    googleUrl: "https://account-dev.afirstsoft.cn/api/v1/auth/google/oauth2"
  };
  api_config = dockerdev;
}
if (ENVdocker === 'dockertest') {
  let dockertest = {
    API_URL: "https://hitpaw-test-api-docker.afirstsoft.cn/app",
    WS_API_URL: "wss://hitpaw-test-api-docker.afirstsoft.cn/app",
    API_V2_URL: "https://hitpaw-test-api-docker.afirstsoft.cn/api/v2/",
    googleUrl: "https://account-test-docker.afirstsoft.cn/api/v1/auth/google/oauth2"
  };
  api_config = dockertest;
}
if (ENVdocker === 'dockerstage') {
  let dockerstage = {
    API_URL: "https://hitpaw-stage-api.afirstsoft.cn/app",
    WS_API_URL: "wss://hitpaw-stage-api.afirstsoft.cn/app",
    API_V2_URL: "https://hitpaw-stage-api.afirstsoft.cn/api/v2/",
    googleUrl: "https://account-stage.afirstsoft.cn/api/v1/auth/google/oauth2"
  };
  api_config = dockerstage;
}
if (ENVdocker === 'dockeruat') {
  let dockeruat = {
    API_URL: "https://hitpaw-uat-api.afirstsoft.cn/app",
    WS_API_URL: "wss://hitpaw-uat-api.afirstsoft.cn/app",
    API_V2_URL: "https://hitpaw-uat-api.afirstsoft.cn/api/v2/",
    googleUrl: "https://account-uat.afirstsoft.cn/api/v1/auth/google/oauth2"
  };
  api_config = dockeruat;
}
if (ENVdocker === 'dockerprod') {
  let dockerprod = {
    API_URL: "https://hitpaw-prod-api.afirstsoft.cn/app",
    WS_API_URL: "wss://hitpaw-prod-api.afirstsoft.cn/app",
    API_V2_URL: "https://hitpaw-prod-api.afirstsoft.cn/api/v2/",
    googleUrl: "https://account-prod.afirstsoft.cn/api/v1/auth/google/oauth2"
  };
  api_config = dockerprod;
}

export { api_config };
